module.exports = __webpack_public_path__ + "img/radio_smooth_scotland.32a30c8c.jpg";